import { getListBobotKomponenKaryatulis } from "@/services/getData"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { useQuery } from "@tanstack/react-query"

export default function MasterBobotKomponenKaryatulisPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listBobotKomponenKaryatulis"],
    queryFn: getListBobotKomponenKaryatulis,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
